// eslint-disable-next-line no-restricted-imports

import React from 'react';
import { Box, Paragraph } from '@99designs/emu';
import { colors } from '@99designs/emu/settings';
import { Button } from '@99designs/frontend-components/components/Button';
import { default as BasePopoverCard } from '@99designs/frontend-components/components/PopoverCard/components/PopoverCard';

export interface Props {
    heading: string;
    message: string;
    storageKey: string;
    storageSource: Storage;
    selector?: string;
    color?: colors.Color;
    children?: React.ReactNode;
}

interface State {
    isDismissed: boolean;
}

export default class StoredPopoverCard extends React.Component<Props, State> {
    state = {
        isDismissed: false,
    };

    componentDidMount() {
        const { storageSource, storageKey } = this.props;
        this.setState({
            isDismissed: storageSource.getItem(storageKey) !== null,
        });
    }

    onDismiss() {
        const { storageSource, storageKey } = this.props;
        this.setState({ isDismissed: true });
        storageSource.setItem(storageKey, 'Got it');
    }

    render() {
        const { selector, heading, message, color } = this.props;
        const variations = [this.state.isDismissed ? 'hidden' : 'onboarding-prompt'];

        return (
            <BasePopoverCard
                layerSelector={selector}
                placement="top"
                variations={variations}
                card={
                    <Box color={color ?? 'pacific'}>
                        <h5 className="heading heading--h5">{heading}</h5>
                        <Paragraph>{message}</Paragraph>
                        <Button
                            variations={['primary', 'small', 'chameleon']}
                            onClick={() => this.onDismiss()}
                        >
                            {__('Got it')}
                        </Button>
                    </Box>
                }
            >
                <span>{this.props.children}</span>
            </BasePopoverCard>
        );
    }
}
